
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore } from "@/store/store-accessor";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import DynamicDataFields from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFields.vue";
import DynamicDataDialog from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataDialog.vue";
import { DynamicFieldOutput } from "@/types/dynamic-data";
import Icon from "@/components/UI/Icon.vue";
import { DynamicFieldReturnType } from "@/types/dynamic-property-path";

@Component({
  components: {
    Icon,
    DynamicDataDialog,
    DynamicDataFields,
    DropdownInput,
    TextInput
  }
})
export default class DynamicDataChooser extends Vue {
  @Prop()
  accepts!: DynamicFieldReturnType | false;

  @Prop()
  value!: DynamicFieldOutput | undefined;

  @Prop()
  path!: string;

  @Prop({ default: 10 })
  iconSize!: number;

  isDialogOpen = false;

  get dynamicFields() {
    return configStore.dynamicFields;
  }

  // There's no point in letting the user open the dialog if there's nothing for them to select
  get areThereFieldsForAcceptsType() {
    if (this.accepts === false) return false;

    const accepts = this.accepts;

    return this.dynamicFields.some(field =>
      field.returnTypes.includes(accepts)
    );
  }

  openDialog() {
    this.isDialogOpen = true;
  }

  closeDialog() {
    this.isDialogOpen = false;
  }

  setDynamicField(dynamicField: DynamicFieldOutput) {
    this.$emit("input", dynamicField);
  }
}
